import { styled } from '@lichtblick/styled';
import { Colors, Spacing, BorderRadius } from '@lichtblick/theme';

import { MessageDialog } from '../../Dialog';

export const ButtonContainer = styled.div<{ $isMargin: boolean }>`
  display: flex;
  gap: ${Spacing.Xs};
  ${({ $isMargin }) => $isMargin && `margin-left: auto;`}
`;

export const CustomRejectDialog = styled(MessageDialog)`
  background-color: ${Colors.red[10]};
  border: 2px solid ${Colors.red[100]};

  .dialogCloseButton {
    background-color: ${Colors.red[100]};
    svg {
      color: ${Colors.white};
    }
  }
`;

export const CustomApproveDialog = styled(MessageDialog)`
  background-color: ${Colors.green[10]};
  border: 2px solid ${Colors.green[100]};

  .dialogCloseButton {
    background-color: ${Colors.green[100]};
    svg {
      color: ${Colors.white};
    }
  }
`;

export const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S};
  margin-bottom: -${Spacing.Xs};
  width: 100%;

  > button {
    margin-left: auto;
    margin-top: auto;
  }
`;

export const ImageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacing.Xs};
  margin-bottom: ${Spacing.M};
`;

export const ImageContainer = styled.div`
  border: 1px solid ${Colors.gray[20]};
  border-radius: ${BorderRadius.S};
  height: 80px;
  overflow: hidden;
  position: relative;
  width: 120px;
`;

export const PreviewImage = styled.img`
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
`;
